import { revenueBreakdownChartInstanceLabels } from "./custom-converter/revenue-breakdown-chart";
import { chartTypeOverylaySorter } from "./shared";
import { ConverterInput } from "./types";

export const apiDataToInstanceLabels = (inputParams: ConverterInput) => {
  const { chartConfigDetails, chartId } = inputParams;

  if (chartId === "revenue-breakdown-chart") {
    return revenueBreakdownChartInstanceLabels(inputParams);
  }

  return chartConfigDetails.chartDatas
    .slice()
    .sort(chartTypeOverylaySorter)
    .map((chartData) => {
      return chartData.label;
    });
};
